import Header from "./header";
import Home from "./home"
import AboutUs from "./aboutUs";
import Services from "./services";
import ContactUs from "./branches";
import Footer from "./footer";
import Divider from "./divider";
import Stats from "./stats";
import Loader from "./Loader";
import BookingGstInfo from "./Info-Section";
import TermsAndConditions from "./term_And_Cond";
import "../kns.css"

import { useEffect, useState, useRef } from "react";

function MainPage(){
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1500); // ⏱ fake loading delay
  
      return () => clearTimeout(timer);
    }, []);

/* -- Scroll -- */
const progressRef = useRef(null);
useEffect(() => {
  const updateProgressBar = () => {
    const el = progressRef.current;
    if (!el) return;

    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    el.style.width = `${scrollPercent}%`;

    // Move the glowing dot
    const dot = el.querySelector(".scroll-indicator-glow");
    if (dot) {
      dot.style.transform = `translateX(${el.offsetWidth - 10}px)`; // move to end
    }
  };

  window.addEventListener("scroll", updateProgressBar);
  return () => window.removeEventListener("scroll", updateProgressBar);
}, []);


    return (
        <div>
            {loading ? (
        <Loader />
      ) :(
            <>
                <div ref={progressRef} className="scroll-progress-bar">
                  <div className="scroll-indicator-glow"></div>
                </div>
                <Header></Header>
                <Home></Home>
                <Divider fill="#f9d423" type="wavy"></Divider>
                <AboutUs></AboutUs>
                <Divider fill="#f9d423" flipped type="wavy"></Divider>
                <Services></Services>
                <Stats></Stats>
                <Divider fill="#6185c9" secondaryFill="#4D6694" tertiaryFill="#1d438a" type="mountains"></Divider>
                <BookingGstInfo></BookingGstInfo>
                <Divider fill="#6185c9" flipped secondaryFill="#4D6694" tertiaryFill="#1d438a" type="mountains"></Divider>
                <ContactUs></ContactUs>
                <TermsAndConditions></TermsAndConditions>
                <Footer></Footer>
            </>
      )
      }      
        </div>
        
        
    );
}
export default MainPage